import { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import BundleProductItem from '../BundleProductItem';

import { ItfEcoCartInventoryPolicy } from 'eco-design/elements/eco-cart/type.d';
import './index.scss';

// 定义产品类型
type ProductItem = {
    productId: string;
    variantId: string;
    quantity: number;
    price: string;
    compareAtPrice: string;
    img: string;
    variantImg: string;
    productTitle: string;
    skuTitle: string;
    inventoryPolicy?: ItfEcoCartInventoryPolicy;
    inventoryQuantity?: number;
    variantDescription: string;
    handle: string;
    specific: string;
};

// 定义Bundle类型
type BundleItem = {
    itemId: string;
    itemType: string;
    retrieveId: string;
    score: number;
    variants: ProductItem[];
};

interface BundleProductProps {
    data: BundleItem[];
}

export default function BundleProduct({ data }: BundleProductProps) {
    const prevRef = useRef<HTMLDivElement>(null);
    const nextRef = useRef<HTMLDivElement>(null);

    const prefixCls = 'temp-member-product-ai-recommend';

    // 计算同组内最多的产品数量，用于统一bundle高度
    const maxProductCount = Math.max(...(data?.map((bundle) => bundle?.variants?.length || 0) || [0]));
    const maxItemsForHeight = Math.min(maxProductCount, 3); // 最多支持3个产品

    return (
        <div className={`${prefixCls}-product-bundle`}>
            {/* PC端网格布局 */}
            <div className={`${prefixCls}-product-bundle-container`}>
                {data?.slice(0, 3).map((bundle, index) => (
                    <BundleProductItem key={bundle.itemId || index} bundle={bundle} maxItemsForHeight={maxItemsForHeight} />
                ))}
            </div>

            {/* 移动端 Swiper 布局 */}
            <div className={`${prefixCls}-product-bundle-swiper`}>
                <Swiper
                    modules={[Navigation]}
                    spaceBetween={16}
                    slidesPerView={'auto'}
                    navigation={{
                        prevEl: `.${prefixCls}-bundle-swiper-btn-prev`,
                        nextEl: `.${prefixCls}-bundle-swiper-btn-next`,
                    }}
                    className={`${prefixCls}-bundle-swiper`}
                >
                    {data?.slice(0, 3).map((bundle, index) => (
                        <SwiperSlide key={bundle.itemId || index} className={`${prefixCls}-bundle-swiper-slide`}>
                            <BundleProductItem key={bundle.itemId || index} bundle={bundle} maxItemsForHeight={maxItemsForHeight} />
                        </SwiperSlide>
                    ))}
                </Swiper>

                {/* 移动端导航按钮 */}
                <div className={`${prefixCls}-bundle-swiper-navigation`}>
                    <div ref={prevRef} className={`${prefixCls}-bundle-swiper-btn ${prefixCls}-bundle-swiper-btn-prev`}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M12.5 5L7.5 10L12.5 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <div ref={nextRef} className={`${prefixCls}-bundle-swiper-btn ${prefixCls}-bundle-swiper-btn-next`}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    );
}
